import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var GridIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M15.1299 7.68994H6.69995V15.4199H15.1299V7.68994ZM28.48 7.68994H20.05V15.4199H28.48V7.68994ZM33.4 7.68994H41.83V15.4199H33.4V7.68994ZM15.1299 20.6899H6.69995V28.4199H15.1299V20.6899ZM20.05 20.6899H28.48V28.4199H20.05V20.6899ZM41.83 20.6899H33.4V28.4199H41.83V20.6899ZM6.69995 33.6899H15.1299V41.4199H6.69995V33.6899ZM28.48 33.6899H20.05V41.4199H28.48V33.6899ZM33.4 33.6899H41.83V41.4199H33.4V33.6899Z"
  }));
});
GridIcon.displayName = 'GridIcon';
GridIcon.defaultProps = {
  'aria-label': 'Grid'
};
export default GridIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/GridIcon/index.js
// module id = 1862
// module chunks = 12